import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Button,
  FormGroup,
  FormText,
  Label,
  Input,
} from "reactstrap";
import { FormattedMessage } from "react-intl";

export default function RenameAPLPeriodModal({
  periodName,
  isOpen,
  toggle,
  newName,
  setNewName,
  updateWorkRegistrationTitles,
  setUpdateWorkRegistrationTitles,
  handleRename,
}) {
  return (
    <Modal size="md" isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>{periodName}</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label className="form-label mb-1" for="aplPeriodNewName">
            <FormattedMessage id="Name" />
          </Label>
          <Input
            id="aplPeriodNewName"
            value={newName}
            maxLength={50}
            onChange={(e) => setNewName(e.target.value)}
          />
        </FormGroup>
        <FormGroup check>
          <Input
            id="aplPeriodUpdateTitles"
            type="checkbox"
            checked={updateWorkRegistrationTitles}
            onChange={(e) => setUpdateWorkRegistrationTitles(e.target.checked)}
          />
          <Label check for="aplPeriodUpdateTitles">
            <FormattedMessage id="UpdateWorkRegistrationTitles" />
          </Label>
          <FormText className="d-block">
            <FormattedMessage id="UpdateWorkRegistrationTitlesHelp" />
          </FormText>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button outline color="secondary" onClick={toggle}>
          <FormattedMessage id="Cancel" />
        </Button>
        <Button
          onClick={handleRename}
          color="primary"
          outline
          disabled={newName.trim().length === 0}
        >
          <FormattedMessage id="Continue" />
        </Button>
      </ModalFooter>
    </Modal>
  );
}
